// TinyMCE needs to be imported for tiny-mce react,
// even though these imports are not used directly
// eslint-disable-next-line
import tinymce from 'tinymce/tinymce';
import 'tinymce/themes/silver/theme';
import 'tinymce/plugins/paste';
import 'tinymce/plugins/link';
import 'tinymce/plugins/autoresize';
import 'tinymce/plugins/lists';
import 'tinymce/plugins/code';

import React from 'react';
import {Editor} from '@tinymce/tinymce-react';
export default class SimpleEditor extends React.Component {
    constructor(props) {
        super(props);

        this.init = {
            skin_url: `${process.env.PUBLIC_URL}/assets/skins/ui/oxide`,
            content_css: [`${process.env.PUBLIC_URL}/assets/skins/content/projectsabroad/content.css`,],
            menubar: false,
            branding: false,
            plugins: 'link code autoresize lists paste',
            paste_as_text: true,
            toolbar1:
                'styleselect bold italic underline bullist numlist | alignleft aligncenter alignright | link unlink',
            toolbar2: 'blockquote strikethrough removeformat undo redo code',
            max_height: 500,
            browser_spellcheck: true,
            link_title: false,
            convert_urls: false,
            document_base_url: '/',
            rel_list: [
                {title: 'default', value: ''},
                {title: 'nofollow', value: 'nofollow'},
            ],
            link_class_list: [
                {title: 'None', value: ''},
                {title: 'Purple Gradient', value: 'Btn Btn--gradient-purple'},
            ],
            style_formats: [
                {
                    title: 'Headings',
                    items: [
                        {title: 'Heading 2', format: 'h2'},
                        {title: 'Heading 3', format: 'h3'},
                        {title: 'Heading 4', format: 'h4'},
                        {title: 'Heading 5', format: 'h5'},
                        {title: 'Heading 6', format: 'h6'},
                    ],
                },
                {
                    title: 'Lists',
                    items: [
                        {title: 'Branded List', selector: 'ul', classes: 'ListBrandmarked', exact: true}
                    ]
                }
            ],
        };
    }

    handleEditorChange = (e) => {
        if (this.props.input) {
            this.props.input.onChange(e.target.getContent());
        } else {
            this.props.onChange(e.target.getContent());
        }
    };

    render() {
        return (
            <div>
                <Editor
                    key={this.props.id || ''}
                    initialValue={this.props.initialValue}
                    init={this.init}
                    onChange={this.handleEditorChange}
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/editor/simple_editor.js